import { render, staticRenderFns } from "./BrochureWidget.vue?vue&type=template&id=d9df969e"
import script from "./BrochureWidget.vue?vue&type=script&lang=js"
export * from "./BrochureWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports